
import Form from "./Form.vue";

export default {
  name: "app-listaPreco-create",
  data() {
    return {
      lista: {},
    };
  },
  components: {
    Form,
  },
  computed: {},
  mounted() {},
};
